var React = require('react');

function ShopArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"shop-arrow-left"),React.createElement("path",{"d":"M110.073 255.996c0-9.172 3.502-18.347 10.492-25.344l220.154-220.149c14.005-14.005 36.71-14.005 50.709 0 13.998 13.998 13.998 36.7 0 50.705l-194.802 194.787 194.788 194.794c13.998 13.998 13.998 36.703 0 50.7-13.998 14.011-36.697 14.011-50.702 0l-220.155-220.145c-6.988-7-10.483-16.175-10.483-25.351z","key":1})]);
}

ShopArrowLeft.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = ShopArrowLeft;

ShopArrowLeft.default = ShopArrowLeft;
